import React from 'react';
import './App.css';  // Import global styles for the app
import CountryInformation from './components/CountryInformation'; // Import the CountryInformation component

function App() {
  return (
    <div className="App">
      <h1>Country Information.</h1>
      <CountryInformation />
    </div>
  );
}

export default App;
